const name = 'gtitulosteps'
export default {
  name,

  components: { }, 

  props: {
    titulo: {
        type: String,
        default: 'Título'
    },
    subtitulo: {
        type: String,
        default: 'Subtitulo'
    },
    imagemEmpresa: {
        type: String,
        default: ''
    }
   },

  mounted () { },

  updated () { },

  data () {
    return { }
  },

  methods: { },

  computed: { }, 

};